<block-ui></block-ui>
  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="LookupItemForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="LookupItemForm"></BBSF-TextBox>
            <div [hidden]="true" class="col-md-6">
              <BBSF-TextBox [options]="LookupIdTextBox" [group]="LookupItemForm"></BBSF-TextBox>
            </div>
          </form>
        </div>
        <div class="card-toolbar">
          <!-- begin::Menu -->
          <button href="javascript:;" class="btn btn-sm btn-light-primary me-3" (click)="showGenerateCodeByIdModal(GenerateCodeModal)">
            <i class="fa fa-key me-1"></i>{{utilityService.getResourceValue("GenerateCode")}}
          </button>

          <button type="button" class="btn btn-sm btn-primary" title="Add" (click)="showAddLookupItemModal(AddLookupItemModal)">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>

          <!-- end::Menu -->
        </div>
      </div>
      <div class="card-body py-3">
        <div class="table-responsive">
          <!--begin::Permission list-->
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Id")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("NameInEnglish")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("NameInArabic")}}</th>
                <th class="min-w-150px" *ngIf="!ProductionMode">{{utilityService.getResourceValue("SysName")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Value")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Manageable")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Action")}}</th>


              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">

              <tr *ngFor="let LookupItem of LookupItemPagingResult">
                <td class="text-dark">{{LookupItem.id}}</td>

                <td>
                  {{LookupItem.name.english}}
                </td>
                <td>
                  {{LookupItem.name.arabic}}
                </td>
                <td *ngIf="!ProductionMode">{{LookupItem.sysName}}</td>
                <td>{{LookupItem.value}}</td>
                <td>
                  <span *ngIf="LookupItem.manageable;else default_no">
                    {{utilityService.getResourceValue("Yes")}}
                  </span>
                  <ng-template #default_no>
                    <span>
                      {{utilityService.getResourceValue("No")}}
                    </span>
                  </ng-template>
                </td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a class="drop-item px-3" ngbDropdownItem (click)="showEditLookupItemModal(LookupItem,EditLookupItemModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </a>

                      <a *ngIf="(!(LookupItem.manageable==false&&ProductionMode)||(LookupItem.isParentLookupManageable))"
                         ngbDropdownItem class="drop-item px-3"
                         (click)="showDeleteLookupItemModal(LookupItem,deleteLookupItemModal)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </a>
                    </mat-menu>
                  </div>

                </td>
              </tr>
              <tr *ngIf="LookupItemPagingResult.length == 0">
                <td [attr.colspan]="ProductionMode ? '6' : '7'">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>

          <!--end::Permission list-->
        </div>

      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setLookupItemListResult($event)" *ngIf="IsFilterLoaded" [options]="LookupItemPaging"
                     [group]="LookupItemForm" #LookupItemPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>


  <!-- Add Modal -->
  <ng-template #AddLookupItemModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Add")}} {{utilityService.getResourceValue("LookupItem")}}</h1>
      </div>
      <form [formGroup]="AddLookupItemForm" (ngSubmit)="addLookupItem()">
        <BBSF-MultiLingualTextBox [options]="MultiLingualName" [group]="AddLookupItemForm"></BBSF-MultiLingualTextBox>
        <BBSF-TextBox [options]="SysName" [group]="AddLookupItemForm"></BBSF-TextBox>
        <BBSF-TextBox [options]="Value" [group]="AddLookupItemForm"></BBSF-TextBox>
        <BBSF-TextBox [options]="DisplayOrder" [group]="AddLookupItemForm"></BBSF-TextBox>
        <BBSF-CheckBox [options]="IsManageable" [group]="AddLookupItemForm"></BBSF-CheckBox>
        <div class="text-center pt-7">
          <button type="button" #CloseLookupItemModal id="CloseLookupItemModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>



  <!-- Edit Modal -->
  <ng-template #EditLookupItemModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("LookupItem")}}</h1>
      </div>
      <form [formGroup]="EditLookupItemForm" (ngSubmit)="editLookupItem()">
        <BBSF-MultiLingualTextBox [options]="EditMultiLingualName" [group]="EditLookupItemForm"></BBSF-MultiLingualTextBox>
        <BBSF-TextBox [options]="EditSysName" [group]="EditLookupItemForm"></BBSF-TextBox>
        <BBSF-TextBox [options]="EditValue" [group]="EditLookupItemForm"></BBSF-TextBox>
        <BBSF-TextBox [options]="EditDisplayOrder" [group]="EditLookupItemForm"></BBSF-TextBox>
        <BBSF-CheckBox [options]="EditIsManageable" [group]="EditLookupItemForm"></BBSF-CheckBox>
        <div class="text-center pt-7">
          <button type="button" #CloseEditLookupItemModal id="CloseEditLookupItemModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="submit" class="btn btn-primary btn-sm">{{utilityService.getResourceValue("SaveLabel")}}</button>
        </div>
      </form>

    </div>
  </ng-template>


  <!-- Delete  Modal -->
  <ng-template #deleteLookupItemModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-icon btn-active-color-primary" (click)="modal.dismiss()">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("LookupItem")}}</h1>
      </div>
      <div class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-10 p-6">
        <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
          <span [inlineSVG]="'./src/assets/images/gen044.svg'"></span>
        </span>

        <div class="d-flex flex-stack flex-grow-1">
          <div class="fw-bold">
            <div class="fs-6 text-gray-700">
              {{utilityService.getResourceValue("Delete_Question")}}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center pt-7">
        <button #CloseDeleteLookupItemModal id="CloseDeleteLookupItemModal" type="button"
                class="btn btn-light btn-sm me-3 " data-dismiss="modal" (click)="modal.dismiss()">
          {{utilityService.getResourceValue("CancelLabel")}}
        </button>
        <button type="button" (click)="DeleteLookupItem()"
                class="btn btn-light-danger btn-sm ">
          {{utilityService.getResourceValue("Delete")}}
        </button>
      </div>
    </div>
  </ng-template>




  <!-- GenerateCode Modal -->
  <ng-template #GenerateCodeModal let-modal>
    <div class="modal-header pb-0 border-0 justify-content-end">
      <h5 class="modal-title" id="exampleModalLabel"></h5>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()" class="btn btn-sm btn-icon btn-active-color-primary">
        <span class="svg-icon svg-icon-1">
          <span [inlineSVG]="'./src/assets/images/arr061.svg'"></span>
        </span>
      </button>
    </div>
    <div class="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
      <div class="mb-13 text-center">
        <h1 class="mb-3">{{utilityService.getResourceValue("GenerateCode")}}</h1>
      </div>
      <form [formGroup]="GenerateCodeForm">
        <div>

          <BBSF-TextArea [options]="GenerateCodeTextArea" [group]="GenerateCodeForm" #GenerateCodeInput>
          </BBSF-TextArea>

        </div>
        <div class="text-center pt-7">
          <button type="button" #CloseGenerateCodeModal id="CloseGenerateCodeModal" data-dismiss="modal" aria-label="Close" class="btn btn-light me-3 btn-sm" (click)="modal.dismiss()">{{utilityService.getResourceValue("CancelLabel")}} </button>
          <button type="button" class="btn btn-primary btn-sm" (click)="copyInputMessage()">
            {{utilityService.getResourceValue("CopyToClipboard")}}
          </button>
        </div>
      </form>



    </div>
  </ng-template>



  
